import {Component} from 'react';
import './Archive.scss';
import h from 'react-hyperscript';
import content from 'Assets/data/report-card-overview.json';
import {h4} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
import {toCamelCase, formatDatetimeLong} from 'Src/utils/utils';
import ArchiveEmpty from './ArchiveEmpty';
import ArchiveListItem from './ArchiveListItem';
import ManageMembers from '../ManageMembers/ManageMembers';
import ArchiveDropdown from './ArchiveDropdown';

class Archive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.reportList,
      activeSortId: 'semester',
      semesterAscending: true,
      dateGeneratedAscending: false,
      respondentsAscending: false,
      menuAnchorEl: null,
    };
    this.compareBy = this.compareBy.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    this.setReportList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.reportList !== prevProps.reportList) {
      this.setReportList();
    }
  }

  setReportList() {
    this.setState({
      data: this.props.reportList,
    });
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  }

  sortBy(key) {
    const formattedId = toCamelCase(key.replace('_', '-'));
    const _slug = `${formattedId}Ascending`;
    const arrayCopy = [...this.state.data];
    let colAscending = true;

    if (this.state[_slug]) {
      colAscending = false;
      arrayCopy.reverse();
    }

    arrayCopy.sort(this.compareBy(key));

    this.setState({
      data: arrayCopy,
      semesterAscending: false,
      dateGeneratedAscending: false,
      respondentsAscending: false,
      [_slug]: colAscending,
      activeSortId: formattedId,
    });
  }

  handleMenuClick(e, slug) {
    e.preventDefault();
    this.setMenu(e.currentTarget);
  }

  handleClose() {
    this.setState({
      menuAnchorEl: null,
    });
  }

  setMenu(slug) {
    this.setState({
      menuAnchorEl: slug,
    });
  }

  render() {
    const data = this.state.data;
    const {selectedDistrict = {name: 'District Name Unavailable'}} = this.props;
    const districtComponent = this.props.districtList.length > 1 ? h(
        ArchiveDropdown,
        {
          googleUser: this.props.googleUser,
          setDistrictFilter: this.props.setDistrictFilter,
          districtNames: this.props.districtList,
          districtName: selectedDistrict,
          csrf: this.props.csrf,
          idToken: this.props.idToken,
        },
    ) : h('h4', this.props.selectedDistrict.name);

    if (data) {
      return h(
          'div',
          {
            className: 'report-overview__archive',
          },
          [
            h('div',
                {
                  id: 'archive__breadcrumbs-menu',
                  className: 'flex--wrap',
                }, [
                  h(
                      h4,
                      {
                        key: 'report-overview__header',
                        className: 'report-overview__header',
                      },
                      `${content.archive.title}`
                  ),
                  h(
                      'span',
                      {
                        className: `material-icons text--grey`,
                      },
                      'keyboard_arrow_right'
                  ),
                  districtComponent,
                  h(
                      ManageMembers, {
                        members: this.props.sharedUsers,
                        userStatus: this.props.userStatus,
                        setMembers: this.props.setSharedUsers,
                        googleUser: this.props.googleUser,
                        csrf: this.props.csrf,
                        idToken: this.props.idToken,
                        districtId: this.props.districtId,
                        class: 'display-inline',
                      }
                  )]),
            h(
                BasicCard,
                {
                  key: 'report-overview__card',
                  type: 'basic',
                },
                h('table', null, [
                  h(
                      'thead',
                      {
                        key: 'report-overview__thead',
                      },
                      [
                        h(
                            'tr',
                            {
                              key: 'report-overview__thead-row',
                            },
                            [
                              content.archive.headers.map((item, i) => {
                                const slug = toCamelCase(
                                    item.id.replace('_', '-')
                                );
                                const _slug = `${slug}Ascending`;
                                const classes = `
                                  material-icons margin-right--micro${
                                    this.state.activeSortId === slug ?
                                        ' visible' :
                                        ' invisible'}`;
                                return h(
                                    'th',
                                    {
                                      key: item.id,
                                      className: 'text--grey text--bold',
                                      onClick: () => {
                                        this.sortBy(item.id);
                                      },
                                    },
                                    [
                                      h('span', {
                                        className: classes,
                                      }, this.state[_slug] ?
                                          'arrow_upward' :
                                          'arrow_downward'
                                      ),
                                      item.title,
                                    ]
                                );
                              }),
                              h('th', null, null),
                            ]
                        ),
                      ]
                  ),

                  h('tbody', null, [
                    data.map((item, i) => {
                      const slug = item.report_card_name_slug;
                      const formattedDatetime =
                          formatDatetimeLong(item.created_date);
                      return h(
                          ArchiveListItem,
                          {
                            key: slug,
                            slug: slug,
                            districtId: item.district_id,
                            userStatus: this.props.userStatus,
                            formattedDate: formattedDatetime,
                            reportId: item.district_report_card_id,
                            title: item.report_card_name,
                            missing_data: item.missing_data,
                            districtName: item.district_name,
                            i: i,
                          },
                          null
                      );
                    }),
                  ]),
                ])
            ),
          ]);
    } else {
      return h(
          ArchiveEmpty,
          {
            districtName: this.props.districtName,
            headers: content.archive.headers,
            title: content.archive.title,
          },
          null
      );
    }
  }
}

export default Archive;
